import { FormStore, GlobalStore } from "@roc/feature-app-core";
import { PayoffService } from "../services/payoffService";
import { DocumentStore } from "@roc/feature-documents";
import { LoanStore } from "@roc/feature-loans";
import { action, computed, flow, makeObservable, observable } from "mobx";
import { format } from "date-fns";

const form = {
  fields: {
    loanId: {
      value: '',
      error: null,
      rule: '',
    },
    expectedPayoffDate: {
      value: '',
      error: null,
      rule: '',
    },
    totalInterestReceived: {
      value: '',
      error: null,
      rule: '',
    },
    totalProceeds: {
      value: '',
      error: null,
      rule: '',
    },
    refundToBorrower: {
      value: '',
      error: null,
      rule: '',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class ServicerProvidedDataStore extends FormStore {
  private documentStore: DocumentStore;
  private globalStore: GlobalStore;
  loanStore: LoanStore;
  payoffService: PayoffService;
  loanId: string;

  constructor(
    loanStore: LoanStore,
    documentStore: DocumentStore,
    globalStore: GlobalStore
  ) {
    super({ ...form }, globalStore);
    this.documentStore = documentStore;
    this.globalStore = globalStore;
    this.loanStore = loanStore;
    this.payoffService = new PayoffService();

    makeObservable(this, {
      submitServicerProvidedData: flow,
      loanId: observable,
      setLoanId: action,
      getPayoffData: flow,
    });
  }

  initialize() {
    const { loanDetails } = this.loanStore;
    const { loanClosingData } = loanDetails;
    this.resetStore();
  }


  *getPayoffData(loan: any) {
    const response = yield this.payoffService.getPayoffData(loan.loanId);
    const data = response.data.data;
    var expectedPayoffDate = null;
    if (data.expectedPayoffDate) {
      const [month, day, year] = data?.expectedPayoffDate?.split("/").map(Number);
      expectedPayoffDate = new Date(year, month - 1, day)
    }
    this.onFieldChange('loanId', loan.loanId);
    this.onFieldChange('expectedPayoffDate', expectedPayoffDate);
    this.onFieldChange('totalInterestReceived', data.totalInterestReceived);
    this.onFieldChange('totalProceeds', data.totalProceeds);
    this.onFieldChange('refundToBorrower', data.refundToBorrower);
  }

  setLoanId(loanId: string) {
    this.loanId = loanId;
  }

  *submitServicerProvidedData() {
    try {
      this.runFormValidationWithMessage();
      if (this.form.meta.isValid) {
        const data = this.getFormValues();
        yield this.payoffService.updateServicerProvidedData(data);
        yield this.documentStore.documentFormStore.closeCurrentForm();
        yield this.loanStore.refreshLoanDetails();
        this.globalStore.notificationStore.showSuccessNotification({
          message: 'Servicer provided data submitted successfully',
        });
      }
    } catch (e) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'An error occurred while submitting servicer provided data',
      });
    }
  }

  resetStore() {
    this.reset();
    this.loanId = null;
  }
}

export default ServicerProvidedDataStore;
